var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4.40223C2 3.99843 2.32399 3.67109 2.72366 3.67109H15.2915C15.6911 3.67109 16.0151 3.99843 16.0151 4.40223C16.0151 4.80603 15.6911 5.13337 15.2915 5.13337H3.44732V20.5377H17.5271V11.4097C17.5271 11.006 17.8511 10.6786 18.2508 10.6786C18.6505 10.6786 18.9744 11.006 18.9744 11.4097V21.2689C18.9744 21.6727 18.6505 22 18.2508 22H2.72366C2.32399 22 2 21.6727 2 21.2689V4.40223Z",
    fill: "#FF5F14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2061 5.47479L18.5954 4.85132L12.3874 11.0593L12.0729 11.9916L12.998 11.683L19.2061 5.47479ZM13.604 12.5171L10.9219 13.4119C10.7788 13.4596 10.6077 13.2851 10.6564 13.1409L11.5679 10.4386L19.3843 2.62217C20.4346 2.15145 21.8218 3.4685 21.4566 4.58961L21.4205 4.70064L13.604 12.5171ZM20.595 4.0859L19.772 4.90889L19.1612 4.28542L19.9921 3.45457C20.3075 3.3995 20.6651 3.75863 20.595 4.0859Z",
    fill: "#FF5F14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.400b1595f535b64a0417f2a988d613b7.svg";
export { ForwardRef as ReactComponent };